/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseModuleGradeResultData } from './genericApiResponseModuleGradeResultData';
import type { GenericApiResponseModuleGradeResultMessage } from './genericApiResponseModuleGradeResultMessage';
import type { GenericApiResponseModuleGradeResultPagination } from './genericApiResponseModuleGradeResultPagination';
import type { GenericApiResponseModuleGradeResultError } from './genericApiResponseModuleGradeResultError';

export interface GenericApiResponseModuleGradeResult {
  data?: GenericApiResponseModuleGradeResultData;
  message?: GenericApiResponseModuleGradeResultMessage;
  pagination?: GenericApiResponseModuleGradeResultPagination;
  error?: GenericApiResponseModuleGradeResultError;
  statusCode?: number;
}
